import { render, staticRenderFns } from "./modelHiqList.vue?vue&type=template&id=fb788efa&scoped=true&"
import script from "./modelHiqList.vue?vue&type=script&lang=js&"
export * from "./modelHiqList.vue?vue&type=script&lang=js&"
import style0 from "./modelHiqList.vue?vue&type=style&index=0&id=fb788efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb788efa",
  null
  
)

export default component.exports